import Navbar from "../../components/organisms/Navbar/Navbar";
import MapPlaceholder from "../../components/organisms/MapPlaceholder/MapPlaceholder";

const AlertsTemplate = ({ onRequestAccess }) => (
  <>
    <Navbar onRequestAccess={onRequestAccess} />
    <MapPlaceholder />
  </>
);

export default AlertsTemplate;
